import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/custom-component/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import CustomLoader from '../common/CustomLoader';
import { loadExternalApis } from '../../features/external-api/redux/loadExternalApis';
import { REST_API } from 'drapcode-constant';
import { checkCustomComponentPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import { CustomFunctionEditForm } from './custom-function/CustomFunctionEditForm';
import CustomFunctionForm from './custom-function/CustomFunctionForm';
import CustomFunctionLogs from './custom-function/CustomFunctionLogs';

export class CustomFunctionEditPage extends Component {
  static propTypes = {
    customComponent: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { activeTab: 'customFunction', customFunctionId: '' };

  componentDidMount = () => {
    const { match, actions } = this.props;
    const { projectId, version, customFunctionId } = match.params;

    actions.loadProjectDetailCustomComponent({ projectId, version });
    actions.loadCustomComponentConfigs({ projectId, version });
    if (customFunctionId !== undefined) {
      this.setState({ customFunctionId });
      actions.loadCustomFunctionDetail({ projectId, customFunctionId, version });
    }
    loadExternalApis({ projectId, version, externalApiType: REST_API });

    // Check if URL ends with customFunctionEdit to toggle tab
    console.log(
      'This is the windows Location path',
      window.location.pathname.includes('customFunction'),
    );
    if (window.location.pathname.includes('customFunction')) {
      this.setState({ activeTab: 'customFunction' });
    }
  };

  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.customComponent;
    if (prevProps.customComponent.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
        // Can use projectType if needed
      }
    }
  }

  componentMenuToggle = (activeTab) => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    this.setState({ activeTab });
    history.push(`/2.0/custom-component/${version}/v/${projectId}/${activeTab}`);
  };

  appSettingToggle = (activeTab) => {
    const { history, match } = this.props;
    const { projectId, version } = match.params;
    history.push(`/2.0/app-setting/${version}/v/${projectId}/setting/${activeTab}`);
  };

  aiModelToggle = (activeTab) => {
    const { history, match } = this.props;
    const { projectId, version } = match.params;
    history.push(`/2.0/app-setting/${version}/v/${projectId}/setting/${activeTab}`);
  };

  render() {
    const isAllowed = checkCustomComponentPermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent containerClassName="customComponent">
          <PermissionDenied message="Custom Function" />
        </CommonPageComponent>
      );
    }

    const { match, customComponent, home, history, externalapi, actions } = this.props;
    const { projectDetail, customDataMappings, loadProjectDetailCustomComponentPending } =
      customComponent;

    const { projectId, version, customFunctionId } = match.params;
    const { activeTab } = this.state;
    const { collections, pages, events } = home;
    if (loadProjectDetailCustomComponentPending || !projectDetail) {
      return (
        <CommonPageComponent parentClassName="">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
              <CustomLoader
                loading={loadProjectDetailCustomComponentPending}
                size="20px"
                color="#303453"
              />
            </div>
          </div>
        </CommonPageComponent>
      );
    }
    return (
      <CommonPageComponent containerClassName="customComponent">
        <AppSettingsNav
          activeTab={activeTab}
          projectDetail={projectDetail}
          advanceAppConstantToogle={this.appSettingToggle}
          customComponentMenuToogle={this.componentMenuToggle}
          CustomCSSJSMenuToogle={this.appSettingToggle}
          SnapshotMenuToogle={this.appSettingToggle}
          AIModelMenuToggle={this.aiModelToggle}
        />

        <div className={`tab-pane ${activeTab === 'customFunction'}`}>
          {window.location.pathname.includes('customFunction/logs') &&
          customFunctionId !== undefined ? (
            <CustomFunctionLogs
              customFunctionId={customFunctionId}
              collections={collections}
              history={history}
              pages={pages}
              events={events}
              projectId={projectId}
              actions={actions}
              version={version}
            />
          ) : customFunctionId !== undefined ? (
            <CustomFunctionEditForm
              collections={collections}
              customFunctionId={customFunctionId}
              history={history}
              pages={pages}
              events={events}
              actions={actions}
              projectId={projectId}
              version={version}
            />
          ) : (
            <CustomFunctionForm
              collections={collections}
              history={history}
              pages={pages}
              events={events}
              projectId={projectId}
              actions={actions}
              version={version}
            />
          )}
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    customComponent: state.customComponent,
    home: state.home,
    externalapi: state.externalapi,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomFunctionEditPage);
